import { getCompressedAssetUrl } from 'lib/config/assetUrls';

export type experienceData = {
  vidSrc: string;
  poster: string;
  message: string;
  name: string;
};

export const indianExperiences: experienceData[] = [
  {
    vidSrc:
      'https://public-web-assets-cfront.ultrahuman.com/cyborg-stories/Anupama.mp4',
    poster: 'web_v2/home/testimonial-India/anupama.webp/w_900',
    message: '"My mindset towards my diet changed"',
    name: 'Anupama Shivacharya',
  },
  {
    vidSrc:
      'https://public-web-assets-cfront.ultrahuman.com/cyborg-stories/SandeepMall.mp4',
    poster: 'web_v2/home/testimonial-India/sandeep.webp/w_900',
    message: '"I was able to add 15 years to my lifespan"',
    name: 'Sandeep Mall',
  },
  {
    vidSrc:
      'https://public-web-assets-cfront.ultrahuman.com/cyborg-stories/SharanNair.mp4',
    poster: 'web_v2/home/testimonial-India/sharan.webp/w_900',
    message: '"What did not work for most people, worked for me"',
    name: 'Sharan Nair',
  },
  {
    vidSrc:
      'https://public-web-assets-cfront.ultrahuman.com/cyborg-stories/Nayanatara.mp4',
    poster: 'web_v2/home/testimonial-India/nayantara.webp/w_900',
    message:
      '"I feel the best on a daily basis, I think this balance is my new definition of fitness."',
    name: 'Nayanatara Menon Bagla',
  },
  {
    vidSrc:
      'https://public-web-assets-cfront.ultrahuman.com/cyborg-stories/KeiranDSouza.mp4',
    poster: 'web_v2/home/testimonial-India/kieren.webp/w_900',
    message: '"The Ultrahuman M1 gives me the confidence to trust how I feel"',
    name: "Kieren D'Souza",
  },
];

export const globalExperiences: experienceData[] = [
  {
    poster: 'web_v2/home/testimonial-uae/4.webp/w_900',
    vidSrc:
      getCompressedAssetUrl('/cyborg-stories/ae/horizontal/Jackie_30Sec_Horizontal_Lock.mp4'),
    message: '"My mindset towards my diet changed"',
    name: 'Jackie',
  },
  {
    poster: 'web_v2/home/testimonial-uae/jesse.webp/w_900',
    vidSrc:
      getCompressedAssetUrl('/cyborg-stories/ae/horizontal/Jesse_30Sec_Horizontal_Lock.mp4'),
    message: '"I was able to add 15 years to my lifespan"',
    name: 'Jesse',
  },
  {
    poster: 'web_v2/home/testimonial-uae/1.webp/w_900',
    vidSrc:
      getCompressedAssetUrl('/cyborg-stories/ae/horizontal/Maddy_30Sec_Hor_ Packaged.mp4'),
    message: '"What did not work for most people, worked for me"',
    name: 'Maddy Black',
  },
  {
    poster: 'web_v2/home/testimonial-uae/3.webp/w_900',
    vidSrc:
      getCompressedAssetUrl('/cyborg-stories/ae/horizontal/Rami_30Sec_Horizontal].mp4'),
    message:
      '"I feel the best on a daily basis, I think this balance is my new definition of fitness."',
    name: 'Rami',
  },
  {
    poster: 'web_v2/home/testimonial-uae/5.webp/w_900',
    vidSrc:
      getCompressedAssetUrl('/cyborg-stories/ae/horizontal/Sarah_30Sec_Hor_Packaged.mp4'),
    message: '"The Ultrahuman M1 gives me the confidence to trust how I feel"',
    name: 'Sarah Nash',
  },
];
